import { useTranslation } from 'react-i18next'
import React, { Fragment, useState } from 'react'

import Link from '../../../../components/actions/Link'
import ModalMenu from '../../../../components/navigation/ModalMenu'
import PlacesCard from './PlacesCard'
import { usePlaceActionsList } from '../../../../utils/actions/place/list'

const UserListItem = ({ item }) => {
  const { t } = useTranslation()
  const [actionsOpen, setActionsOpen] = useState(false)
  const [options] = usePlaceActionsList(item)

  return (
    <Fragment>
      <Link block onClick={() => setActionsOpen(true)}>
        <PlacesCard item={item} />
      </Link>
      <ModalMenu t={t} open={actionsOpen} onClose={() => setActionsOpen(false)} options={options} />
    </Fragment>
  )
}

export default UserListItem
